export const GLASS =
    'bg-white/20 backdrop-blur-xl backdrop-saturate-150 border border-white/60 shadow-[0_10px_36px_rgba(15,23,42,0.06),inset_0_1px_0_rgba(255,255,255,0.65)] rounded-[28px]';

export const GLASS_SM =
    'bg-white/25 backdrop-blur-xl backdrop-saturate-150 border border-white/60 shadow-[0_6px_24px_rgba(15,23,42,0.05),inset_0_1px_0_rgba(255,255,255,0.65)] rounded-2xl';

export const PAGE_BG = 'linear-gradient(to bottom, #FFFFFF 0%, #FDF6F9 40%, #FCF3F6 75%, #FFFFFF 100%)';

export const PAGE_TITLE =
    'font-heading text-foreground text-[2rem] leading-[1.14] sm:text-[2.5rem] sm:leading-[1.08] md:text-[3rem] md:leading-[1.05] lg:text-[3.15rem] lg:leading-[1.04] xl:text-[3.4rem] tracking-[-0.015em] [text-wrap:balance]';
